module.exports = __webpack_public_path__ + "img/bash.6384cd5d.svg";